<template>
  <div class="home-page">
    <wx-open-launch-weapp
      v-show="form == 'micromessenger'"
      id="launch-btn"
      username="gh_45b306365c3d"
      path="pages/shop/index/index?shopId=10454314"
      @ready="ready"
      @launch="launch"
      @error="error"
    >
    <script type="text/wxtag-template">
      <button 
        style="padding: 0px;border: 0px;outline: none;width: 128px;
          height: 40px;background: #FC4C5C;border-radius: 8px;margin-top: 470px;
          margin-bottom: 30px;text-align: center;font-size: 14px;font-family: PingFang SC;
          font-weight: 400;line-height: 40px;color: #FFFFFF;opacity: 1;"
      >上京东购</button>
    </script>
    </wx-open-launch-weapp>
    <a href="https://ur.alipay.com/5Qf5kC" v-show="form != 'micromessenger'" class="btn">上天猫购</a>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { axios } from './utils/request.js';

export default {
  name: 'App',
  data () {
    return {
      form:''
    }
  },
  methods: {
    judgeWhereFrom(){
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {  
        this.form = 'micromessenger';
        console.log('micromessenger');
        this.text();
      } else if(ua.match(/Alipay/i)=="alipay"){   
        this.form = 'alipay';
      }else{
        console.log('其他浏览器');
      } 
    },
    ready(e){
      console.log('ready1', e)
    },
    launch (e) {
      console.log('success1', e)
    },
    error (e) {
      console.log('fail2', e);
    },
    async text () {
      const code = this.getURLParameter('code');
      // this.code = code
      if (code) {
        this.form = 'micromessenger';
        const result = await axios.get(`mbr/members/getWxJsConfigByCode?code=${code}&url=${encodeURIComponent(location.href.split('#')[0])}`);
        //this.code = result;
        if (result.data.errcode == 0) {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: result.data.data.jsConfig.appId, // 必填，公众号的唯一标识
            timestamp: JSON.stringify(result.data.data.jsConfig.timestamp), // 必填，生成签名的时间戳
            nonceStr: result.data.data.jsConfig.nonceStr, // 必填，生成签名的随机串
            signature: result.data.data.jsConfig.signature,// 必填，签名
            jsApiList: result.data.data.jsConfig.jsApiList, // 必填，需要使用的JS接口列表
            openTagList: result.data.data.jsConfig.openTagList // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']
          });
          // 通过ready接口处理成功验证
          wx.ready(function (res) {
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
            console.log('readysuccess', res);
            // alert(JSON.stringify('wx.success'));
            //this.list = res;
          });
          // 通过error接口处理失败验证
          wx.error(function (res) {
            // alert('wx.error',JSON.stringify(res));
            console.log('res',res);
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名
          });
          //sessionStorage.setItem('ACCESS_TOKEN', result.data.data.memberInfo.token);
        } else {
          // alert('接口错误', JSON.stringify(result));
        }
      } else {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {  
          this.form = 'micromessenger';
          window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx838673ad2b635047&redirect_uri=https%3A%2F%2Fapi.mbr.massestech.com&response_type=code&scope=snsapi_userinfo&state=#wechat_redirect";
        } else if(ua.match(/Alipay/i)=="alipay"){   
          this.form = 'alipay';
        }else{
          console.log('其他浏览器');
        } 
      }
    },
    getURLParameter (variable) {
      const url = window.location.href
      //  this.code = url
      const search = url.substring(url.lastIndexOf('?') + 1)

      const obj = {}
      const reg = /([^?&=]+)=([^?&=]*)/g
      search.replace(reg, (rs, $1, $2) => {
        const name = decodeURIComponent($1)
        let val = decodeURIComponent($2)
        val = String(val)
        obj[name] = val
        return rs
      })
      return obj[variable];
    }
  },
  components: {
  },
  mounted () {
   
  },
  created(){
    this.text();
    // this.judgeWhereFrom();
  }
}
</script>

<style lang="less">
*{
  margin: 0;
  padding: 0;
  font-size: 100%;
}
button{
  /*消除button的默认样式*/
  /*这种写法是对所有的button标签同时生效*/
  margin: 0px;
  padding: 0px;
  /*自定义边框*/
  border: 0px;
  /*消除默认点击蓝色边框效果*/
  outline: none;
}
a{
  text-decoration: none;
}
.home-page {
  background: url("./assets/bg.png") no-repeat center;
  background-size: 100% auto;
  display: flex;
  justify-content: center;
  .btn{
    width: 128px;
    height: 40px;
    background: #FC4C5C;
    border-radius: 8px;
    margin-top: 540px;
    margin-bottom: 30px;
    text-align: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 40px;
    color: #FFFFFF;
    opacity: 1;
  }
}
</style>
